import * as amplitude from "@amplitude/analytics-browser";
import { Icon, Text } from "@chakra-ui/react";
import { RiRefreshLine } from "react-icons/ri";
import { FormStatusMenu } from "src/components/Menus/FormStatusMenu";
import { Glossary } from "src/components/Text/Glossary";
import { getBulkFormStatusDialogCopy } from "src/constants";
import { useConfirmationDialog } from "src/hooks/useConfirmationDialog";
import * as GQL from "src/types/graphql";
import { useBulkActionTargets } from "./bulkActionTargetsContext";
import { useEnqueueBulkForm } from "./useEnqueueBulkForm";

export const FormStatusMenuBulkAsync = () => {
  const bulk = useBulkActionTargets();
  const enqueueBulkForm = useEnqueueBulkForm();

  const { confirm, confirmationDialog, setBody, setHeader } =
    useConfirmationDialog({
      header: null,
      body: null,
      cancelButton: {
        label: "Cancel",
      },
      confirmButton: {
        label: "Yes, change status",
        colorScheme: "blue",
      },
      translate: true,
    });

  const handleOnSelectStatusChange = async (value: GQL.form_status_enum) => {
    const copy = getBulkFormStatusDialogCopy(value, bulk.selectionSize);
    setHeader(
      <Text>
        <Glossary>{copy.header}</Glossary>
      </Text>
    );
    setBody(
      <Text>
        <Glossary>{copy.body}</Glossary>
      </Text>
    );

    amplitude.track("Clicked bulk update form status", {
      count: bulk.selectionSize,
      status: value,
    });
    if (await confirm()) {
      amplitude.track("Confirmed bulk update form status", {
        count: bulk.selectionSize,
        status: value,
      });

      await enqueueBulkForm({
        actionType: "SET_FORM_STATUS",
        actionData: { status: value },
      });
    } else {
      amplitude.track("Canceled bulk update form status", {
        count: bulk.selectionSize,
        status: value,
      });
    }
  };

  return (
    <>
      <FormStatusMenu
        formStatus={undefined}
        label="Update status"
        leftIcon={<Icon as={RiRefreshLine} />}
        onSelect={handleOnSelectStatusChange}
        isLoading={false}
      />
      {confirmationDialog}
    </>
  );
};
